<template>
    <div v-if="loadComponent">
        <v-form>
            <v-container>
                <h1>Awards and Commendations</h1>
                <v-row>
                    <v-col cols="12" xs="12" sm="6" md="4" class="pb-0 mb-0">
                        <v-text-field label="Code"
                                      :class="classPadding"
                                      v-model="awards.code"></v-text-field>
                    </v-col>
                    <v-col cols="12" xs="12" sm="6" md="8" class="pb-0 mb-0">
                        <v-text-field label="Description"
                                      :class="classPadding"
                                      v-model="awards.desc"></v-text-field>
                    </v-col>
                </v-row>
                <!--RLV:05Jul2022-->
                <v-row>
                    <v-col cols="12" xs="12" sm="6" md="4" :class="classPadding">
                        <v-checkbox label="Is For PMS"
                                    :class="classPadding"
                                    v-model="awards.isForPMS"></v-checkbox>
                    </v-col>
                </v-row>

                <v-row>
                    <v-col cols="12" xs="12" sm="12" md="12" :class="classPadding">
                        <v-btn color="success"
                               :loading="isSaving"
                               :class="classPadding"
                               @click.stop="save"
                               v-if="userAccess.add >= 1">Save</v-btn>
                    </v-col>
                </v-row>
            </v-container>
        </v-form>

        <v-container>
            <pagination :key="componentKey">
                <template slot="actions" slot-scope="{ item }">
                    <v-btn @click.stop="edit(item)" text icon v-if="userAccess.edit >= 1">
                        <v-icon color="primary">mdi-pencil</v-icon>
                    </v-btn>
                    <v-btn @click.stop="deleteItem(item)"
                           text
                           icon
                           v-if="userAccess.delete >= 1">
                        <v-icon color="error">mdi-delete</v-icon>
                    </v-btn>
                </template>
            </pagination>

            <v-dialog v-model="editDialog" width="700" persistent>
                <v-card>
                    <v-card-title>
                        <span class="headline">Edit</span>
                    </v-card-title>
                    <v-card-text>
                        <v-row>
                            <v-col cols="12" xs="12" sm="6" md="6" :class="classPadding">
                                <v-text-field label="Code"
                                              :class="classPadding"
                                              v-model="editAwards.code"
                                              disabled></v-text-field>
                            </v-col>
                            <v-col cols="12" xs="12" sm="6" md="6" :class="classPadding">
                                <v-text-field label="Description"
                                              :class="classPadding"
                                              v-model="editAwards.desc"></v-text-field>
                            </v-col>
                        </v-row>
                        <!--RLV:05Jul2022-->
                        <v-row>
                            <v-col cols="12" xs="12" sm="6" md="4" :class="classPadding">
                                <v-checkbox label="Is For PMS"
                                            :class="classPadding"
                                            v-model="editAwards.isForPMS"></v-checkbox>
                            </v-col>
                        </v-row>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn text color="error" @click.stop="editDialog = false">Close</v-btn>
                        <v-btn text
                               color="success"
                               @click.stop="update"
                               :loading="isUpdating"
                               v-if="userAccess.update >= 1">Update</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-container>
    </div>
</template>
<script>
    import Pagination from "./Pagination";
    import userAccessMixin from "../../../../../mixins/userAccessMixin";
    // import List from "./List";
    const API_ENDPOINT = "/api/awards";
    export default {
        metaInfo: {
            title: "Awards and Commendations",
            titleTemplate: `%s - ${process.env.VUE_APP_NAME}`
        },
        mixins: [userAccessMixin],
        components: {
            // List
            Pagination
        },
        data: () => ({
            classPadding: "my-0 py-0",
            isSaving: false,
            isUpdating: false,
            awards: {},
            componentKey: 0,
            editAwards: {},
            editDialog: false,
            isForPMS: false, /*RLV:05Jul2022*/
            editIsForPMS: false /*RLV:05Jul2022*/
        }),
        methods: {
            save() {
                this.isSaving = true;
                this.$axios
                    .post(`${API_ENDPOINT}`, this.awards)
                    .then(({ data }) => {
                        this.$toast.success(data.message);
                        this.reset();
                    })
                    .catch(({ response }) => {
                        this.$toast.error(response.data.message);
                    })
                    .finally(() => {
                        this.isSaving = false;
                    });
            },
            edit(item) {
                var rel = Object.assign({}, item);
                this.editAwards = rel;

                /*RLV:05Jul2022*/
                this.editIsForPMS = rel.isForPMS;

                this.editDialog = true;

            },
            deleteItem(item) {
                this.$confirm(this.$deleteConfirm, {
                    color: "error",
                    title: "Delete"
                }).then(res => {
                    if (res) {
                        this.$axios
                            .delete(`${API_ENDPOINT}/${item.code}`)
                            .then(({ data }) => {
                                this.$toast.success(data.message);
                                this.reset();
                            })
                            .catch(({ response }) => {
                                this.$toast.error(response.data.message);
                            });
                    }
                });
            },
            reset() {
                this.awards = {};
                this.forceRerender();
                this.editDialog = false;
                this.isForPMS = false;
            },
            forceRerender() {
                this.componentKey += 1;
            },
            update() {
                this.isUpdating = true;

                this.$axios
                    .put(`${API_ENDPOINT}`, this.editAwards)
                    .then(({ data }) => {
                        this.$toast.success(data.message);
                        this.reset();
                    })
                    .catch(({ response }) => {
                        this.$toast.error(response.data.message);
                    })
                    .finally(() => {
                        this.isUpdating = false;
                    });
            }
        },
        created() {
            this.getUserAccessRights("AwardComm");
        }
    };
</script>